import {Directive, ReflectiveInjector} from "@angular/core";
import {Router} from "@angular/router";
import {Aot2JitSharingService} from "../../../services/aot2jitsharing.service";

class HrefDirectiveClass {

  public href;
  public router;

  constructor() {
    let injector = ReflectiveInjector.resolveAndCreate([Aot2JitSharingService]);
    let aot2JitSharingService = injector.get(Aot2JitSharingService);
    this.router = aot2JitSharingService.getProvider(Router);
  }

  public navigateToPage(event) {

    if(event.target.nodeName == 'A') {

      let openInBlank = false;
      if(event.ctrlKey || event.metaKey) {
        openInBlank = true;
      }
      if(event.target.hasAttribute('target') && event.target.getAttribute('target') == '_blank') {
        openInBlank = true;
      }

      let host = event.target.hostname;
      if(openInBlank) {
        window.open(this.href, '_blank');
      }
      else {
        if (host == 'howmuch.net' || host == 'localhost' || host == '0.0.0.0' || host == '127.0.0.1') {
          if (this.router != null) {
            this.router.navigateByUrl(event.target.pathname);
          }
        }
        else {
          window.location.href = this.href;
        }
      }
    }

  }

}

let HrefDirective = Directive({
  selector : '[href]',
  inputs: ['href'],
  host : {
    '(click)' : 'navigateToPage($event)'
  }
})(HrefDirectiveClass);


export { HrefDirective, HrefDirectiveClass };





// WEBPACK FOOTER //
// ./src/app/shared/directives/article/directives/href.directive.ts